export const ij_websocket = Symbol('websocket');
export const ij_chatId = Symbol('chatId');
export const ij_callLogId = Symbol('callLogId');
export const ij_showMyLanguage = Symbol('showMyLanguage');
export const ij_toggleShowMyLanguage = Symbol('toggleShowMyLanguage');
export const ij_mappingProfile = Symbol('mappingProfile');
export const ij_mappingProfileThis = Symbol('mappingProfileThis');
export const ij_setMappingProfile = Symbol('setMappingProfile');
export const ij_setMappingProfileColor = Symbol('setMappingProfileColor');
export const ij_setMappingProfileNickname = Symbol('setMappingProfileNickname');
export const ij_setMappingProfileLanguage = Symbol('setMappingProfileLanguage');
export const ij_chatMessageAudience = Symbol('chatMessageAudience');
export const ij_chatMessageScreen = Symbol('chatMessageScreen');
export const ij_setMessageSpeaker = Symbol('setMessageSpeaker');
export const ij_isOnBiggerText = Symbol('isOnBiggerText');
export const ij_toggleIsOnBiggerText = Symbol('toggleIsOnBiggerText');
export const ij_isVisibleButtonMyLanguage = Symbol('isVisibleButtonMyLanguage');
export const ij_popBubbleEmpty = Symbol('popBubbleEmpty');
export const ij_setEmptyBubbleMy = Symbol('setEmptyBubbleMy');
export const ij_setEmptyBubbleOther = Symbol('setEmptyBubbleOther');
export const ij_setEmptyBubbleScreen = Symbol('setEmptyBubbleScreen');
export const ij_serviceName = Symbol('serviceName');
export const ij_isLastIsOwn = Symbol('isLastIsOwn');
export const ij_isLastMessage = Symbol('isLastMessage');
export const ij_isOldMessage = Symbol('isOldMessage');
export const ij_isLastIsOther = Symbol('isLastIsOther');
export const ij_endCall = Symbol('endCall');
export const ij_isEndedCall = Symbol('isEndedCall');
export const ij_settingMaxLines = Symbol('settingMaxLines');
export const ij_settingMaxWidth = Symbol('settingMaxWidth');
export const ij_settingIsOnlyComplete = Symbol('settingIsOnlyComplete');
export const ij_setSettingMaxLines = Symbol('setSettingMaxLines');
export const ij_isOnCamera = Symbol('isOnCamera');
export const ij_isOnDisplayCamera = Symbol('isOnDisplayCamera');
export const ij_setSettingMaxWidth = Symbol('setSettingMaxWidth');
export const ij_setSettingIsOnlyComplete = Symbol('setSettingIsOnlyComplete');
export const ij_setSettingIsOnCamera = Symbol('setSettingIsOnCamera');
export const ij_setSettingIsOnDisplayCamera = Symbol('setSettingIsOnDisplayCamera');
export const ij_incrementMsgIndex = Symbol('incrementMsgIndex');
export const ij_isLanguageSlowRead = Symbol('isLanguageSlowRead');
export const ij_bottomBarStatus = Symbol('bottomBarStatus');
export const ij_setBottomBarStatus = Symbol('setBottomBarStatus');
export const ij_currentPopupMicInput = Symbol('currentPopupMicInput');
export const ij_setCurrentPopupMicInput = Symbol('setCurrentPopupMicInput');
export const ij_isVisibleSecretController = Symbol('isVisibleSecretController');
export const ij_toggleIsVisibleSecretController = Symbol('toggleIsVisibleSecretController');
export const ij_sendMessageMt = Symbol('sendMessageMt');
export const ij_deleteMessageMt = Symbol('sendMessageMt');
export const ij_languageHome = Symbol('languageHome');
export const ij_languageAway = Symbol('languageAway');
export const ij_setLanguageHome = Symbol('setLanguageHome');
export const ij_setLanguageAway = Symbol('setLanguageAway');
export const ij_isActiveFaceToFace = Symbol('isActiveFaceToFace');
export const ij_toggleIsActiveFaceToFace = Symbol('toggleIsActiveFaceToFace');
export const ij_languageArea = Symbol('languageArea');
export const ij_listTargetArea = Symbol('listTargetArea');
export const ij_setListTargetArea = Symbol('setListTargetArea');
export const ij_toggleModalLanguage = Symbol('toggleModalLanguage');
export const ij_messageList = Symbol('messageList');
export const ij_classTheme = Symbol('classTheme');
export const ij_onboardingUserInput = Symbol('onboardingUserInput');
export const ij_partnerSelected = Symbol('partnerSelected');
export const ij_listContract = Symbol('listContract');
export const ij_fetchAllContracts = Symbol('fetchAllContracts');
export const ij_hasContractActive = Symbol('hasContractActive');
export const ij_hasVoiceRegistered = Symbol('hasVoiceRegistered');
export const ij_getListVoiceRegistered = Symbol('getListVoiceRegistered');
export const ij_setMenuCurrent = Symbol('setMenuCurrent');
export const ij_isPlanCancelled = Symbol('isPlanCancelled');
export const ij_userCreditUsed = Symbol('userCreditUsed');
export const ij_hasShownVoiceModal = Symbol('hasShownVoiceModal');
export const ij_isVisibleSecretLangaugeChange = Symbol('isVisibleSecretLangaugeChange');
export const ij_toggleIsVisibleSecretLangaugeChange = Symbol('toggleIsVisibleSecretLangaugeChange');
export const ij_ableMicList = Symbol('ableMicList');
export const ij_settingTextSize = Symbol('settingTextSize');
export const ij_setSettingTextSize = Symbol('setSettingTextSize');
export const ij_isShrinkTarget = Symbol('isShrinkTarget');
export const ij_resetSubtitle = Symbol('resetSubtitle');
export const ij_settingMaxWidthLimit = Symbol('settingMaxWidthLimit');
export const ij_settingLineHeight = Symbol('settingLineHeight');
export const ij_setSettingLineHeight = Symbol('setSettingLineHeight');
export const ij_settingColorBackground = Symbol('settingColorBackground');
export const ij_setSettingColorBackground = Symbol('setSettingColorBackground');
export const ij_widthMax = Symbol('widthMax');
export const ij_chat_mode = Symbol('chatMode');
export const ij_paymentMethod = Symbol('ij_paymentMethod');
export const ij_isCardDomestic = Symbol('isCardDomestic');
export const ij_isUserCardDomestic = Symbol('isUserCardDomestic');
export const ij_paymentTypeForCheckout = Symbol('paymentTypeForCheckout');
export const ij_isScreenFull = Symbol('isScreenFull');
export const ij_settingIsVisibleLogo = Symbol('settingIsVisibleLogo');
export const ij_setSettingIsVisibleLogo = Symbol('setSettingIsVisibleLogo');
export const ij_chat_ui = Symbol('chatUi');
export const ij_chatCode = Symbol('chatCode');
export const ij_isVisibleAuxiliaryDisplayControl = Symbol('isVisibleAuxiliaryDisplayControl');
export const ij_openAuxiliaryDisplayControl = Symbol('openAuxiliaryDisplayControl');
export const ij_closeAuxiliaryDisplayControl = Symbol('closeAuxiliaryDisplayControl');
export const ij_settingsScreenRemoteCached = Symbol('settingsScreenRemoteCached');
export const ij_settingsSubtitleRemoteCached = Symbol('settingsSubtitleRemoteCached');
export const ij_settingsSubtitleCached = Symbol('settingsSubtitleCached');
export const ij_settingsScreenCached = Symbol('settingsScreenCached');
export const ij_isModeSubtitle = Symbol('isModeSubtitle');
export const ij_isModeScreen = Symbol('isModeScreen');
export const ij_settingsCached = Symbol('settingsCached');
export const ij_domain = Symbol('domain');
